/* unplugin-vue-components disabled */import { render } from "./popupPicture.vue?vue&type=template&id=8123696c&scoped=true"
import script from "./popupPicture.vue?vue&type=script&lang=js"
export * from "./popupPicture.vue?vue&type=script&lang=js"

import "./popupPicture.vue?vue&type=style&index=0&id=8123696c&scoped=true&lang=css"

import exportComponent from "E:\\work\\weitu_land_page_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8123696c"]])

export default __exports__